module.exports = __webpack_public_path__ + "img/company-icon.3487320e.svg";